import { Button } from '@talentmesh/ui/components/button';
import { UserIcon, XCircleIcon } from 'lucide-react';
import { useActionDialogContext } from '../Context/ActionDialogContext';

interface DialogListProps {
    title: string;
    readonly?: boolean;
}
function DialogList({ title, readonly }: DialogListProps) {
    const { selectedCandidates, removeCandidate } = useActionDialogContext();

    return (
        <div className="flex h-full flex-col gap-2">
            <h3 className="text-2xl font-bold">{title}</h3>

            <div data-cy="dialogList" className="border-border h-73 overflow-y-auto rounded-md border pb-1">
                <ul className="pl-3">
                    {selectedCandidates.map((item) => {
                        return (
                            <li
                                key={item.candidateId}
                                className="group relative flex flex-row items-center justify-between py-1 pr-4"
                            >
                                <div className="flex flex-row items-center gap-2 font-normal">
                                    <UserIcon className="size-5" />
                                    <span className="text-base">{item.name}</span>
                                </div>
                                {!readonly && (
                                    <Button
                                        variant="ghost"
                                        size="icon-sm"
                                        aria-label="delete"
                                        onClick={() => removeCandidate(item)}
                                        className="text-destructive hover:bg-destructive/10 hover:text-destructive shrink-0"
                                    >
                                        <XCircleIcon />
                                    </Button>
                                )}
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
}

export default DialogList;
